import { filterType, SearchFilter } from "./SearchFilter";

const filterItemsTrafficAnimals: SearchFilter[] = [
  {
    atr: "druh_zveri",
    name: "druh_zveri",
    active: true,
    type: filterType.TEXT
  },{
    atr: "hlavne_priciny_nehody",
    name: "hlavne_priciny_nehody",
    active: true,
    type: filterType.TEXT
  },{
    atr: "celkova_hmotna_skoda",
    name: "celkova_hmotna_skoda",
    active: false,
    type: filterType.TEXT
  },{
    atr: "nasledky_nehody_usmrtene_osoby",
    name: "nasledky_nehody_usmrtene_osoby",
    active: false,
    type: filterType.TEXT
  },{
    atr: "nasledky_nehody_tazko_zranene_osoby",
    name: "nasledky_nehody_tazko_zranene_osoby",
    active: false,
    type: filterType.TEXT
  },{
    atr: "nasledky_nehody_lahko_zranene_osoby",
    name: "nasledky_nehody_lahko_zranene_osoby",
    active: false,
    type: filterType.TEXT
  },{
    atr: "datum",
    name: "datum",
    active: false,
    type: filterType.DATE
  },{
    atr: "hodina",
    name: "hodina",
    active: false,
    type: filterType.TEXT
  },{
    atr: "minuta",
    name: "minuta",
    active: false,
    type: filterType.NONE
  },{
    atr: "id_kraj",  
    name: "id_kraj",
    active: true,
    type: filterType.TEXT
  },{
    atr: "viditelnost",
    name: "viditelnost",
    active: false,
    type: filterType.TEXT
  },{
    atr: "alkohol_u_vinnika_nehody_pritomny",
    name: "alkohol_u_vinnika_nehody_pritomny",
    active: false,
    type: filterType.TEXT
  },{
    atr: "stav_povrchu_vozovky_v_dobe_nehody",
    name: "stav_povrchu_vozovky_v_dobe_nehody",
    active: false,
    type: filterType.TEXT
  },{
    atr: "vyrobna_znacka_motoroveho_vozidla",
    name: "vyrobna_znacka_motoroveho_vozidla",
    active: false,
    type: filterType.TEXT
  }
];

export default filterItemsTrafficAnimals;